import { useEffect, useMemo } from "react"

import * as turf from "@turf/turf"

import { useGeoServerRetrieveFeature } from "@l2r-front/l2r-geodata"
import { CANVAS_MIN_BBOX_WIDTH, useMapDispatchContext } from "@l2r-front/l2r-map"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { useNetworksStateContext } from "../../contexts/NetworksContext"

export function MapAdapterFeature(props) {

    const {
        feature,
        featureId,
    } = props

    const { getMapRef, setMapBoundingBoxToFit } = useMapDispatchContext()
    const mapRef = getMapRef()
    const { selectedNetwork } = useNetworksStateContext()

    const { data: segment, refetch } = useGeoServerRetrieveFeature(featureId, null, {}, {
        enabled: !!featureId && !feature,
    })

    useEffect(() => {
        if (!feature && featureId && selectedNetwork) {
            refetch()
        }
    }, [feature, featureId, selectedNetwork, refetch])

    const roadBoundingBox = useMemo(() => {
        if (!segment && !feature) {
            return null
        }

        const roadFeature = turf.featureCollection([feature ?? segment])
        const [minLng, minLat, maxLng, maxLat] = turf.bbox(roadFeature)
        const lngOffset = Math.max((CANVAS_MIN_BBOX_WIDTH - (maxLng - minLng)), 0) / 2

        return ({
            minLng: minLng - lngOffset,
            minLat,
            maxLng: maxLng + lngOffset,
            maxLat,
        })
    }, [feature, segment])

    useEffect(() => {
        if (roadBoundingBox && mapRef) {
            setMapBoundingBoxToFit(roadBoundingBox)
        }
    }, [mapRef, roadBoundingBox, setMapBoundingBoxToFit])

    return null
}

MapAdapterFeature.propTypes = {
    feature: PropTypes.object,
    featureId: PropTypes.string,
}